module.exports = __webpack_public_path__ + "static/media/heat_good.92e82407.svg";